export const RECEIPT_DEFAULTS = {
  printer_name: "",
  paper_mm: 80,
  printable_mm: 72,
  margin_mm: 3,
  font_size: 12,
  line_height: 1.35,
  font_family: "monospace",
  logo_enabled: false,
  logo_url: "",
  logo_mm: 40,
  title: "ХОТЕЛ РЕСТОРАНТ ВЪРБИЦА",
  subtitle: "",
  footer: "Благодарим Ви!",
  extra_lines: [],
  show: { datetime: true, table: true, waiter: true, receipt_no: true, unit_price: true, notes: false, vat: true, discount: true, payment: true, nonfiscal_note: true, footer: true },
  labels: {
    table: "Маса", waiter: "Сервитьор", date: "Дата", receipt: "Бележка №", subtotal: "Сума",
    discount: "Отстъпка", total: "ОБЩО", vat: "в т.ч. ДДС", payment: "Плащане", cash: "В брой", card: "С карта",
    prebill: "ПРЕДВАРИТЕЛНА СМЕТКА", copy: "КОПИЕ", nonfiscal: "Служебен бон – не е фискален",
  },
};

export const RECEIPT_TOGGLES = [
  ["datetime", "Дата и час"], ["table", "Маса"], ["waiter", "Сервитьор"], ["receipt_no", "Номер на бележката"],
  ["unit_price", "Единична цена"], ["notes", "Бележки към артикулите"], ["vat", "ДДС"], ["discount", "Отстъпка"],
  ["payment", "Начин на плащане"], ["nonfiscal_note", "Надпис „не е фискален“"], ["footer", "Текст в края"],
];

export const INVOICE_BLOCKS = {
  header: { label: "Заглавие, номер и дата", locked: true },
  parties: { label: "Доставчик и получател", locked: true },
  stay: { label: "Данни за престоя" },
  lines: { label: "Таблица с услуги", locked: true },
  totals: { label: "Суми и ДДС", locked: true },
  payment: { label: "Плащане" },
  notes: { label: "Бележки" },
  signatures: { label: "Подписи" },
  footer: { label: "Долен колонтитул" },
};

export const INVOICE_DEFAULTS = {
  printer_name: "",
  margins_mm: { top: 15, right: 15, bottom: 15, left: 15 },
  font_size: 11,
  font_family: "Manrope",
  accent: "#1E3B27",
  text_color: "#1f2937",
  logo_url: "",
  logo_mm: 40,
  logo_align: "left",
  title: "ФАКТУРА",
  original_label: "ОРИГИНАЛ",
  header_note: "",
  footer_text: "",
  spacing_mm: 6,
  blocks: ["header", "parties", "stay", "lines", "totals", "payment", "notes", "signatures", "footer"],
  hidden: [],
  labels: {
    supplier: "Доставчик", recipient: "Получател", number: "Номер", date: "Дата на издаване",
    eik: "ЕИК", vat_number: "ДДС №", address: "Адрес", mol: "МОЛ", phone: "Телефон", email: "Имейл",
    bank: "Банка", iban: "IBAN", stay: "Престой", arrival: "Пристигане", departure: "Заминаване",
    room: "Стая", nights: "Нощувки", base: "Данъчна основа", vat: "ДДС", total: "Сума за плащане",
    payment_method: "Начин на плащане", payment_status: "Статус на плащане", notes: "Бележки",
    compiled: "Съставил", received: "Получил", cancelled: "АНУЛИРАНА",
  },
  columns: [
    { key: "idx", label: "№", visible: true },
    { key: "description", label: "Описание", visible: true, locked: true },
    { key: "quantity", label: "Кол.", visible: true, locked: true },
    { key: "unit", label: "Мярка", visible: true },
    { key: "unit_price", label: "Ед. цена с ДДС", visible: true, locked: true },
    { key: "vat_rate", label: "ДДС %", visible: true, locked: true },
    { key: "base", label: "Основа", visible: true },
    { key: "vat", label: "ДДС", visible: false },
    { key: "total", label: "Стойност", visible: true, locked: true },
  ],
};

export const COMPANY_FIELDS = [
  ["legal_name", "Име на фирмата (по регистрация) *"], ["eik", "ЕИК *"], ["vat_number", "ДДС номер (ако сте регистрирани)"],
  ["address", "Адрес на управление *"], ["mol", "МОЛ"], ["phone", "Телефон"], ["email", "Имейл"], ["bank", "Банка"], ["iban", "IBAN"],
];

export const FISCAL_DEFAULTS = { enabled: false, url: "http://localhost:8001", printer_id: "", tax_groups: { 20: 2, 9: 4, 0: 1 } };

export const PAYMENT_METHODS = { CASH: "В брой", CARD: "С карта", BANK: "Банков превод" };
export const PAYMENT_STATUSES = { PAID: "Платена", UNPAID: "Неплатена", PARTIAL: "Частично платена" };

export const mergeTpl = (defaults, saved) => ({
  ...defaults, ...(saved || {}),
  show: { ...(defaults.show || {}), ...((saved || {}).show || {}) },
  labels: { ...defaults.labels, ...((saved || {}).labels || {}) },
  ...(defaults.margins_mm ? { margins_mm: { ...defaults.margins_mm, ...((saved || {}).margins_mm || {}) } } : {}),
});
